import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';

import { BetslipConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { Subject, map } from 'rxjs';

import { BetslipPick } from '../../../core/picks/betslip-pick';
import { orderPicksByTypeState } from '../../utils/bet-type.utils';
import { BaseSingleBetComponent } from './base-single-bet.component';

@Component({
    selector: 'bs-digital-single-bet',
    templateUrl: './single-bet.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./single-bet.component.scss'],
    standalone: false,
})
export default class SingleBetComponent extends BaseSingleBetComponent {
    onListRendered$ = new Subject<BetslipPick[]>();
    isListRendered = toSignal(this.onListRendered$.pipe(map(() => true)), { initialValue: false });

    singleBetState = computed(() => this.viewModel().singleBetState);

    private orderedPickList = computed(() => {
        return orderPicksByTypeState(this.viewModel().pickList, this.viewModel().singleBetState);
    });

    orderedPickList$ = toObservable(this.orderedPickList);

    constructor(
        betslipConfig: BetslipConfig,
        public override sitecore: Sitecore,
    ) {
        super(betslipConfig, sitecore);
    }
}
